import { DefaultTheme } from "styled-components";

const hasNumber = (password: string) => new RegExp(/[0-9]/).test(password);
const hasMixed = (password: string) => new RegExp(/[a-z]/).test(password) && new RegExp(/[A-Z]/).test(password);
const hasSpecial = (password: string) => new RegExp(/[!#@$%^&*)(+=._-]/).test(password);

const strengthIndicator = (password: string) => {
  let strengths = 0;
  if (password.length > 5) {
    strengths += 1;
  }
  if (password.length > 7) {
    strengths += 1;
  }
  if (hasNumber(password)) {
    strengths += 1;
  }
  if (hasSpecial(password)) {
    strengths += 1;
  }
  if (hasMixed(password)) {
    strengths += 1;
  }
  return strengths;
};

export const getPasswordStrengthInfo = (password: string, theme: DefaultTheme) => {
  const strength = strengthIndicator(password);
  switch (strength) {
    case 0:
    case 1:
      return { strength, label: "Poor", color: theme.colors.error.main };
    case 2:
      return { strength, label: "Weak", color: theme.colors.warning.light };
    case 3:
      return { strength, label: "Normal", color: theme.colors.info.main };
    case 4:
      return { strength, label: "Good", color: theme.colors.success.light };
    case 5:
      return { strength, label: "Strong", color: theme.colors.success.main };
    default:
      return { strength, label: "Poor", color: theme.colors.error.main };
  }
};
